( function( window, document, $ ) {
    'use strict';

} )( window, document, jQuery );
